import { useEffect, useRef, useState } from "react";
import { MFButton } from "../../../../common/components/MFButton";
import MFModal from "../../../../common/containers/MFModal";

export function ModalManageFolder({
  isOpen,
  onClose,
  folder,
  createFolder,
  updateFolder,
  onCreate,
}) {
  const [label, setLabel] = useState("");
  const inputRef = useRef();

  useEffect(() => {
    if (folder) {
      setLabel(folder.label || "");
    }
  }, [folder]);

  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  const handleSaveFolder = async () => {
    if (folder?._id && updateFolder) {
      updateFolder({ id: folder._id, label });
    } else {
      createFolder({ label });
      setLabel("");
      if (onCreate) onCreate();
    }
    onClose();
  };

  return (
    <MFModal
      isOpen={isOpen}
      onClose={onClose}
      dialogClassName="folder-modal-container"
    >
      <p className="modal-title text-center">
        {folder?._id ? "Renommer le dossier" : "Créer un dossier"}
      </p>
      <form onSubmit={(e) => e.preventDefault()}>
        <div>
          <label htmlFor="label">Nom du dossier</label>
          <input
            id="label"
            placeholder="Dossier n°1"
            className="form-control"
            onChange={(e) => setLabel(e.target.value)}
            value={label}
            ref={inputRef}
          />
        </div>
        <div className="d-flex align-items-center justify-content-center mt-4">
          <MFButton
            style={{ fontSize: 15 }}
            className="mr-1"
            onClick={handleSaveFolder}
          >
            Valider
          </MFButton>
          <MFButton style={{ fontSize: 15 }} cancelButton onClick={onClose}>
            Annuler
          </MFButton>
        </div>
      </form>
    </MFModal>
  );
}
